function createStore(reducer, preloadedState) {
    var state = preloadedState;
    var listeners = [];
    var getState = function () { return state; };
    var subscribe = function (listener) {
        var subscribed = true;
        listeners.push(listener);
        return function () {
            if (!subscribed) {
                return;
            }
            subscribed = false;
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    };
    var dispatch = function (action) {
        state = reducer(state, action);
        for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
            var listener = listeners_1[_i];
            listener();
        }
    };
    dispatch({});
    return {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
    };
}
export { createStore as default, };
//# sourceMappingURL=createStore.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/small-redux/es5-esm/createStore.js
// module id = +3YZ
// module chunks = 3 10